export const Card = ({ children }) => (
    <div className="p-4 border rounded-lg shadow-md bg-white">{children}</div>
  );
  
  export const CardContent = ({ children }) => (
    <div className="p-2">{children}</div>
  );